module.exports = __webpack_public_path__ + "static/pedestal-zoom-354323f5b745e623a57497bb9b797c5c.jpg";